import { render, staticRenderFns } from "./TcAppointmentFormSuccess.vue?vue&type=template&id=20d1677f&"
import script from "./TcAppointmentFormSuccess.vue?vue&type=script&lang=js&"
export * from "./TcAppointmentFormSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d1677f')) {
      api.createRecord('20d1677f', component.options)
    } else {
      api.reload('20d1677f', component.options)
    }
    module.hot.accept("./TcAppointmentFormSuccess.vue?vue&type=template&id=20d1677f&", function () {
      api.rerender('20d1677f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcAppointmentFormSuccess.vue"
export default component.exports